import { render } from "./PlayerControlls.vue?vue&type=template&id=d975f354"
import script from "./PlayerControlls.vue?vue&type=script&lang=js"
export * from "./PlayerControlls.vue?vue&type=script&lang=js"

import "./PlayerControlls.vue?vue&type=style&index=0&id=d975f354&lang=scss"
script.render = render

export default script